import { brand } from "@/shared/lib/safecheckBrand";

export const statisticsDashboardSummary = {
  admissions: 1487,
  invoicedUsd: 0,
  companies: 2,
  hospitals: 149,
  year: 2026,
};

export const statisticsKeyIndicators = [
  {
    id: "admissions",
    value: 1487,
    icon: "home",
    color: "text-primary",
    bg: "bg-primary-soft",
    footerKey: "thisYear",
    footerColor: "text-muted",
    footerIcon: "trending",
  },
  {
    id: "invoicedAmount",
    value: 0,
    icon: "dollar",
    color: "text-green",
    bg: "bg-accent-soft",
    footerKey: "usdYear",
    footerColor: "text-muted",
    footerIcon: "dollar",
  },
  {
    id: "avgCost",
    value: 0,
    icon: "file",
    color: "text-teal",
    bg: "bg-teal-soft",
    footerKey: "usd",
    footerColor: "text-muted",
    footerIcon: "calculator",
  },
  {
    id: "companies",
    value: 2,
    icon: "building",
    color: "text-purple",
    bg: "bg-purple-soft",
    footerKey: "active",
    footerColor: "text-green",
    footerIcon: "check",
  },
  {
    id: "hospitals",
    value: 149,
    icon: "hospital",
    color: "text-yellow",
    bg: "bg-yellow-soft",
    footerKey: "partners",
    footerColor: "text-muted",
    footerIcon: "map",
  },
  {
    id: "employees",
    value: 691,
    icon: "users",
    color: "text-pink",
    bg: "bg-pink-soft",
    footerKey: "activeEmployees",
    footerColor: "text-green",
    footerIcon: "userCheck",
  },
] as const;

export const statisticsMonthlyTrend = [
  { month: "Juil 25", value: 0 },
  { month: "Aoû 25", value: 0 },
  { month: "Sep 25", value: 0 },
  { month: "Oct 25", value: 0 },
  { month: "Nov 25", value: 0 },
  { month: "Déc 25", value: 0 },
  { month: "Jan 26", value: 42 },
  { month: "Fév 26", value: 168 },
  { month: "Mar 26", value: 336 },
  { month: "Avr 26", value: 322 },
  { month: "Mai 26", value: 248 },
  { month: "Jun 26", value: 198 },
];

export const statisticsMonthlyInvoiced = statisticsMonthlyTrend.map((item) => ({
  ...item,
  value: 0,
}));

export const statisticsAdmissionStatuses = [
  { key: "pending", value: 12, color: "#f59e0b" },
  { key: "inProgress", value: 1455, color: brand.navy },
  { key: "completed", value: 12, color: brand.limeDark },
  { key: "transferred", value: 8, color: "#06b6d4" },
];

export const statisticsInvoiceStatuses = [
  { key: "submitted", value: 6, color: "#f59e0b" },
  { key: "underReview", value: 14, color: brand.navy },
  { key: "approved", value: 2, color: brand.limeDark },
];

export const statisticsTopMedicalActs: { name: string; value: number }[] = [];

export const statisticsFrequentDiagnostics: { name: string; value: number }[] = [];

export const statisticsCompanyExpenses: { key: string; value: number; color: string }[] = [];

export const statisticsTopHospitals = [
  { id: "medecin-de-nuit", name: "Medecin de nuit", admissions: 1302, color: brand.navy },
  { id: "afiadonbosco", name: "afiadonbosco", admissions: 160, color: brand.navyLight },
  { id: "mwangeji", name: "mwangeji", admissions: 25, color: brand.lime },
];
